export default function appendData(values) {
    const formValues = { ...values };
    const formData = new FormData();
    for (const value in formValues) {
      formData.append(value, formValues[value]);
    }
    return formData;
  }